"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var link_1 = require("spry-react/Link/link");
var idGenerator_1 = require("spry-react/utils/idGenerator");
var subContextMenuContainer_1 = require("spry-react/ContextMenu/subContextMenuContainer");
var react_1 = require("react");
function ContextMenu(props) {
    return React.createElement("ul", null, React.Children.map(props.children, function (child) { return React.createElement("li", null, child); }));
}
exports.ContextMenu = ContextMenu;
function ContextMenuItem(props) {
    var classes = classNames(props.iconClass, { disabled: props.disabled });
    return React.createElement(link_1.Link, { className: classes, disabled: props.disabled, onClick: props.onClick, title: props.title }, props.text);
}
exports.ContextMenuItem = ContextMenuItem;
function ContextMenuHeader(props) {
    return React.createElement("p", { className: "drop-menu-header action-list-header" }, props.text);
}
exports.ContextMenuHeader = ContextMenuHeader;
function ColorBoxContextMenuItem(props) {
    return React.createElement(link_1.Link, { onClick: props.onClick, style: { display: 'flex' } },
        React.createElement("div", { style: { display: 'inline-block', width: '1.2rem', height: '1.2rem', backgroundColor: props.color, borderRadius: '4px', marginRight: '.8em' } }),
        props.text);
}
exports.ColorBoxContextMenuItem = ColorBoxContextMenuItem;
function NavigateContextMenuItem(props) {
    var classes = classNames(props.iconClass, { disabled: props.disabled });
    return React.createElement(link_1.Link, { className: classes, url: props.url, targetNewWindow: props.targetNewWindow, disabled: props.disabled, title: props.title }, props.text);
}
exports.NavigateContextMenuItem = NavigateContextMenuItem;
var SubContextMenu = /** @class */ (function (_super) {
    __extends(SubContextMenu, _super);
    function SubContextMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.openSubMenu = function () {
            _this.setState({ isOpen: true });
        };
        _this.closeSubMenu = function () {
            _this.setState({ isOpen: false });
        };
        _this.toggleSubMenu = function () {
            _this.setState(function (prevState) { return ({ isOpen: !prevState.isOpen }); });
        };
        _this.state = {
            isOpen: false
        };
        return _this;
    }
    SubContextMenu.prototype.render = function () {
        var _this = this;
        var positioningElementId = idGenerator_1.GenerateId();
        var contextMenu = {
            key: idGenerator_1.GenerateId(),
            subContextMenuItemId: positioningElementId,
            render: function (data, closeContextMenu) { return React.createElement(React.Fragment, null, _this.props.children); },
        };
        return (React.createElement("div", { style: { position: 'relative' }, id: positioningElementId, onMouseEnter: this.openSubMenu, onMouseLeave: this.closeSubMenu },
            React.createElement("a", { className: this.props.iconClass, style: { paddingRight: '0' }, tabIndex: 0, "aria-haspopup": true, "aria-expanded": this.state.isOpen, onClick: function (e) {
                    _this.toggleSubMenu();
                    e.nativeEvent.stopImmediatePropagation();
                }, onKeyPress: function (e) {
                    if (e.key == 'Enter')
                        _this.toggleSubMenu();
                } },
                this.props.text,
                React.createElement("i", { className: "open-right-icon", style: { float: 'right' } })),
            this.state.isOpen && React.createElement(subContextMenuContainer_1.SubContextMenuContainer, { key: contextMenu.key, contextMenu: contextMenu, closeContextMenu: this.closeSubMenu })));
    };
    return SubContextMenu;
}(React.Component));
exports.SubContextMenu = SubContextMenu;
exports.ContextMenuTriggerClassName = "context-menu-trigger";
function ContextMenuTrigger(props) {
    var id = react_1.useRef(idGenerator_1.GenerateId());
    var ref = react_1.useRef(null);
    var _a = react_1.useState(false), isContextMenuOpen = _a[0], setIsContextMenuOpen = _a[1];
    var openMenu = function () {
        setIsContextMenuOpen(true);
        props.openContextMenu({}, { relativeElementId: id.current }, function () { return setIsContextMenuOpen(false); });
    };
    var onClick = function (e) {
        if (isContextMenuOpen)
            return;
        e.nativeEvent.stopImmediatePropagation();
        openMenu();
    };
    var onKeyPress = function (e) {
        if ((e.key == 'Enter' || e.key == ' ') && ref.current) {
            e.stopPropagation();
            $(ref.current).trigger('click'); //Triggering click instead of opening the menu is a hack so that the context menu will be toggled (i.e. if the context menu is open, and you hit 'Enter' while focusing the trigger element, the context menu will close)
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement("span", { id: id.current, onClick: props.disabled ? function () { } : onClick, ref: ref, "aria-haspopup": true, "aria-expanded": isContextMenuOpen, tabIndex: 0, role: "button", onKeyPress: onKeyPress, className: exports.ContextMenuTriggerClassName }, props.children));
}
exports.ContextMenuTrigger = ContextMenuTrigger;
function ContextMenuIndicator(props) {
    return React.createElement(React.Fragment, null,
        React.createElement(ContextMenuTrigger, { openContextMenu: props.openContextMenu, disabled: props.disabled },
            React.createElement("span", { className: '\r\n        section-header-context-menu-button \r\n        vertical-ellipsis-icon \r\n        no-padding-psuedo-elements' })));
}
exports.ContextMenuIndicator = ContextMenuIndicator;
